/** @jsx jsx */
import React from 'react';
import { Flex, Button, VisuallyHidden, Text, jsx } from 'theme-ui';
import { Link } from 'gatsby';
import { useTypefaceTotal } from '../../cart-provider';
import { Anchor } from '../link';
import { Cart } from '../../icons';

import { useEffect } from 'react';
import { motion, useMotionValue, useTransform } from 'framer-motion';

export default function Counter({ value }) {
  return <motion.span>{value}</motion.span>;
}

export const TypefaceShopTotalSmall = ({ typeface, footnote }) => {
  const typefaceTotal = useTypefaceTotal(typeface);

  return (
    <Flex
      sx={{
        flex: 1,
        minWidth: 'max-content',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: 6,
      }}
    >
      <Text
        as="p"
        variant="h2"
        sx={{ fontWeight: '700', marginRight: [0, 4], marginBottom: [0, 5] }}
      >
        £<Counter value={typefaceTotal} />
      </Text>

      <Anchor to="/cart" variant="buttons.link_invert">
        <Cart sx={{ width: 10 }} />
        {/* <VisuallyHidden as="span">Cart</VisuallyHidden> */}
      </Anchor>
    </Flex>
  );
};
